module.exports = __webpack_public_path__ + "img/preloader493x361.da348cab.gif";